<template>
    <div class="inner-container">
        <div class="section-title program">
            <span>{{ $t("app.links.strategicPlanning") }}</span>
        </div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i>
            <span v-if="$i18n.locale === 'kk'">Мемлекеттік активтер тізілімі</span>
            <span v-else>Реестр государственных активов</span>
        </div>
        <div class="actions-tab in-header">
            <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left"><i class="icon icon-info"></i></span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div class="info-button">
                        <span v-if="$i18n.locale === 'kk'">«Мемлекеттік активтер тізілімі» нұсқаулығы <i class="icon icon-folder"></i></span>
                        <span v-else>Инструкции «Реестр государственных активов» <i class="icon icon-folder"></i></span>
                    </div>
                    <div class="info-button">
                        <span v-if="$i18n.locale === 'kk'">Бейне нұсқаулықтар <i class="icon icon-video"></i></span>
                        <span v-else>Видеоинструкции <i class="icon icon-video"></i></span>
                    </div>
                    <div class="info-text" v-if="$i18n.locale === 'kk'">
                        <p>Мемлекеттік меншік объектілерінің (жылжымайтын және жылжымалы мүлік) тізілімін
                            АБП мен теңгерім ұстаушылар бөлінісінде жүргізуге арналған.</p>
                        <p>Режим келесі бөлімдерден тұрады:</p>
                        <p><span class="red bold">Объектілер тізілімі</span><br />– объектілерді жүргізу және есепке алу</p>
                        <p><span class="red bold">Түгендеу есептері</span><br />– түгендеу нәтижелері бойынша есептерді жүктеу және өңдеу</p>
                    </div>
                    <div class="info-text" v-else>
                        <p>Раздел предназначен для ведения реестра объектов государственной собственности
                            (движимое и недвижимое имущество) в разрезе АБП и балансодержателей.</p>
                        <p>Режим состоит из следующих разделов:</p>
                        <p><span class="red bold">Реестр объектов</span><br />– ведение и учёт объектов государственных активов</p>
                        <p><span class="red bold">Отчёты инвентаризации</span><br />– загрузка и обработка отчётов по результатам инвентаризации</p>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left"><i class="icon icon-download"></i> {{ $i18n.locale === 'kk' ? 'Жүктеп алу' : 'Скачать' }}</span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRegistry">{{ $i18n.locale === 'kk' ? 'Объектілер тізілімі' : 'Реестр объектов' }}</b-dropdown-item>
            </b-dropdown>
        </div>
        <router-view v-if="isCardRoute"></router-view>
        <b-tabs v-show="!isCardRoute">
            <!-- ==================== ВКЛАДКА 1: РЕЕСТР ОБЪЕКТОВ ==================== -->
            <b-tab :title="$i18n.locale === 'kk' ? 'Объектілер тізілімі' : 'Реестр объектов'" active>
                <objects-registry></objects-registry>
            </b-tab>

            <!-- ==================== ВКЛАДКА 2: ОТЧЁТЫ ИНВЕНТАРИЗАЦИИ ==================== -->
            <!-- TODO: некликабельна, пока нет отдельного компонента  -->
            <b-tab :title="$i18n.locale === 'kk' ? 'Түгендеу есептері' : 'Отчёты инвентаризации'" disabled></b-tab>
        </b-tabs>
    </div>
</template>

<script>
import ObjectsRegistry from './ObjectsRegistry.vue';

export default {
    name: 'RegisterAssets',
    components: {
        ObjectsRegistry
    },
    computed: {
        isCardRoute() {
            return this.$route.name === 'register-assets-card';
        }
    },
    methods: {
        downloadRegistry() {
            // TODO: интеграция с sit-py для экспорта в Excel
            console.log('download registry');
        }
    }
};
</script>

